// extracted by mini-css-extract-plugin
export const fallback = "smartfire-components-fallback-block-fallback-block-module__fallback--2koT7";